import React from 'react';
import { IdsButton } from '@investec/ids-web-react';
import { useLocation, useNavigate, useParams } from 'react-router';
import CustomerDataProvider from '../contexts/CustomerDataProvider';
import FocusedForm from '../layouts/FocusedForm/FocusedForm';
import IsaTransferOptionsStep from '../components/IsaTransfer/IsaTransferOptionsStep';
import withFeatureFlags from '../components/FeatureFlags/withFeatureFlags';
import logoImg from '../assets/images/investec-logo.svg';
import closeImg from '../assets/images/close-dark-grey.svg';
import { setPageTitle } from '../utils/helpers';

import '../components/MaturityInstructionForm/maturityInstructionForm.scss';

const IsaTransferPageContainer: React.FC<{
    featureEnabled?: (featureName: string) => boolean;
}> = ({ featureEnabled }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { accountId = '' } = useParams<{ accountId: string }>();
    const initialTransferState = location.state as {
        transferInStatus?: string;
        transferInStatusKnown?: boolean;
    } | null;
    const initialTransferInStatus = initialTransferState?.transferInStatus;
    const initialTransferInStatusKnown = initialTransferState?.transferInStatusKnown === true;

    setPageTitle('Transfer your ISA | Investec Save');

    const returnToDashboard = () => {
        navigate('/');
    };

    return (
        <CustomerDataProvider>
            <FocusedForm className="isa-transfer-page" pageAnalyticsName="ISA Transfer">
                <div className="isa-transfer-page__header">
                    <img src={logoImg} alt="Investec" />
                    <IdsButton
                        className="isa-transfer-page__close"
                        appearance="subtle"
                        size="sm"
                        onClick={returnToDashboard}
                        aria-label="Close ISA transfer"
                    >
                        <img src={closeImg} alt="" />
                    </IdsButton>
                </div>
                <IsaTransferOptionsStep
                    accountId={accountId}
                    initialTransferInStatus={initialTransferInStatus}
                    initialTransferInStatusKnown={initialTransferInStatusKnown}
                    featureEnabled={featureEnabled}
                    onBack={() => navigate(-1)}
                    onClose={returnToDashboard}
                />
            </FocusedForm>
        </CustomerDataProvider>
    );
};

export default withFeatureFlags(IsaTransferPageContainer);
